module.exports = __webpack_public_path__ + "static/media/banner-roxo.0fbd3ce6.jpg";